import { useEffect, useState } from "react";
import { Loader, PageHeader } from "../../components";
import { useComponent } from "../../hooks";
import pages from "../../constants/pages";
import { useSelector } from "react-redux";
import Table from "./list components/Table";

export default function ResourceList({ pageID }) {
  const [resources, setResources] = useState([]);

  const { axios, loader, pagePermissions } = useComponent({ pageID });
  const { ID } = useSelector((state) => state.memberDetails.activeBot);

  useEffect(() => {
    loader.start();
    axios({
      url: "/resources/" + ID,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setResources(response.data);
        loader.apiComplete();
      } else {
        loader.apiComplete();
      }
    });
  }, [axios, loader, ID]);

  return (
    <Loader>
      <PageHeader
        title="Resource List"
        pageName={"Resource List"}
        addIcon={[
          "Add New Resource",
          pages.resourceCreatePage.route,
          pagePermissions.create,
        ]}
      />
      <Table resources={resources} />
    </Loader>
  );
}
